import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ox-alert, [ox-alert]',
  templateUrl: './alert.html'
})

export class AlertComponent implements OnInit {
  @Input() show = true;
  @Input() type = 'success';
  @Input() margin = '';
  @Input() boldMessage = true;
  @Input() whiteBackground = false;
  
  icon = '';
  dismissible = true;


  ngOnInit() {
    if(this.type === 'success') {
      this.icon = 'ui-check';
      this.dismissible = true;
    }
    if(this.type === 'info') {
      this.icon = `ui-${this.type}`;
      this.dismissible = false;
    }
    if (this.type === 'error') {
      this.type = 'danger';
      this.icon ='ui-caution';
      this.dismissible = false;
    }
    if(this.type === 'family') {
      this.type = 'info';
      this.icon = 'graphic-family-sharing';
      this.dismissible = false;
    }
    if(this.type === 'caution') {
      this.type = 'info';
      this.icon ='ui-caution';
      this.dismissible = false;
    }
  }

  hideAlert() {
    if (this.type === 'success') {
      this.show = false;
    }
  }
}
